import { grey } from "@mui/material/colors";
import { styled } from "@mui/material/styles";

export const Root = styled("div")(({ theme }) => ({
  height: "100%",
  backgroundColor:
    theme.palette.mode === "light"
      ? grey[100]
      : theme.palette.background.default,
}));
